// const baseUrl = process.env.NODE_ENV === 'production' ? '/' : '/api'
// const baseUrl="http://127.0.0.1:9000/api/"
// let baseUrl= window.location.protocol + "//" +window.location.hostname
// if(window.location.port !== ''){
//     baseUrl += ":" + window.location.port;
// }
const baseUrl="https://www.doneist.cn/api/"
export default baseUrl